module.exports = __webpack_public_path__ + "static/media/YM75_2.3286ced7.jpg";